import SvgCreator from "components/ReuseableCompos/SvgCreator";
import useMobile from "customHooks/useMobile";
import { useAllTextColors } from "layout/Layout";
import useTranslation from "next-translate/useTranslation";
import Link from "next/link";
import styled from "styled-components";
import { useModeContext } from "../../context/ModeContext";
type Props = {
  data: {
    constant: string;
    desc: string;
    icon: {
      uri: string;
      color: string;
    };
    route: any;
  };
  isLast?: boolean;
  bLeft?: boolean;
  bRight?: boolean;
};
const DonateCard = ({ data, isLast, bLeft, bRight }: Props) => {
  const { route, desc, constant, icon } = data;
  const { t } = useTranslation("common");
  const isMobile = useMobile("lg");
  const { theme } = useModeContext();
  const allColors = useAllTextColors();
  const prefixedRoute = route?.startsWith("/") ? route : `/${route}`;
  return (
    <StyledDonateCard
      bLeft={bLeft}
      bRight={bRight}
      isLast={isLast}
      className={`nav-item mx-0 my-0 my-lg-3 col-lg-4  ${
        !isMobile ? "px-3" : "px-0"
      }`}
      noBorderBottom={isLast}
      theme={theme}
    >
      <Link
        prefetch={false}
        href={prefixedRoute}
        className={`card card-category card-hover shadow cursor py-lg-2 py-3 px-0 px-lg-3 flex-row align-items-center justify-content-between ${
          !isMobile ? "px-0" : "px-3 py-4"
        }`}
      >
        <div className="v-centered">
          <div className="donate-card-icon" style={{ minWidth: 60 }}>
            <SvgCreator
              color={allColors[icon?.color ?? "green"]}
              uri={icon.uri}
              p={"p-2"}
              hwm="60"
              hwd="60"
            />
          </div>
          <div className="ms-2">
            <h4 className="card-title h5 mb-1  mb-lg-0"> {t(constant)}</h4>
            <p className="mb-0 fs-sm text-muted">{t(desc)}</p>
          </div>
        </div>
        {!isMobile && (
          <StyledChevron theme={theme}>
            <i className="fe-chevron-right fs-xxl fw-normal chev-color "></i>
          </StyledChevron>
        )}
      </Link>
    </StyledDonateCard>
  );
};

export default DonateCard;
const StyledChevron = styled.i`
  .chev-color {
    color: ${(props) => "var(--dark-gray)"} !important;
    transition: color 0.2s ease-in-out;
  }
  a:hover & {
    .chev-color {
      color: var(--primary2) !important;
    }
  }
`;
const StyledDonateCard = styled.li<{
  isLast: boolean;
  noBorderBottom: boolean;
  bLeft?: boolean;
  bRight?: boolean;
}>`
  @media (max-width: 991.98px) {
    margin-bottom: 0 !important;
    margin-bottom: 0 !important;
    border-bottom: ${(props) =>
      props.noBorderBottom
        ? "none !important"
        : `1px solid var(--light-gray) !important;`};
    border-left: ${(props) =>
      !props.bLeft
        ? "none !important"
        : `1px solid var(--light-gray) !important;`};

    border-right: ${(props) =>
      !props.bRight
        ? "none !important"
        : `1px solid var(--light-gray) !important;`};
    a {
      border: none !important;
      box-shadow: none !important;
      border-radius: 0 !important;
      display: flex !important;
      flex-direction: column !important;
    }
    .v-centered {
      display: flex !important;
      flex-direction: column !important;
    }
    .ms-2 {
      margin-left: 0 !important;
      margin-right: 0 !important;
      text-align: center !important;
    }
    .donate-card-icon {
      background-color: var(--light-gray) !important;
      padding: 0.5rem !important;
      margin-bottom: 0.5rem !important;
    }
    .card.card-hover:hover,
    .shadow-hover:hover,
    .card.card-active {
      border-color: var(--light-gray) !important;
      box-shadow: none !important;
    }
  }
`;
